import {
  Layout,
  Photo,
  PhotoMarker,
  Unit,
  MarkerAttributes,
  CreateAreaTagData,
  RawPhotoMarker,
} from '../types/types';
import { GET, POST } from '@/shared/api/requests';

export const getLayouts = async (projectId: string, type?: string): Promise<Layout[]> => {
  const url = type
    ? `/projects/${projectId}/layouts/?type=${type}`
    : `/projects/${projectId}/layouts/`;
  const response = await GET(url);
  return response.data.layouts || [];
};

export const getAreaTags = async (layoutId: string, projectId: string): Promise<Unit[]> => {
  const response = await GET(`/area-tags/?layout_id=${layoutId}&project_id=${projectId}`);
  const data = response.data;
  return Array.isArray(data) ? data : data.results || [];
};

export const getPhotoMarkers = async (layoutId: string): Promise<PhotoMarker[]> => {
  const response = await GET(`/layouts/${layoutId}/markers/`);
  const rawMarkers: RawPhotoMarker[] = response.data.markers || [];
  return rawMarkers.map((marker: RawPhotoMarker) => ({
    id: marker.index,
    dbId: marker.id,
    number: marker.index,
    x: marker.x,
    y: marker.y,
    photos: marker.photos || [],
    width: marker.width,
    height: marker.height,
    fontSize: marker.font_size,
  }));
};

export const getAvailablePhotos = async (layoutId: string): Promise<Photo[]> => {
  return (await GET(`/layouts/${layoutId}/photos/`)).data;
};

export const getPhoto360 = async (photoId: number) => {
  return (await GET(`/photos/${photoId}/360/`)).data;
};

export const createAreaTag = async (data: CreateAreaTagData) => {
  return (await POST(`/area-tags/?project_id=${data.project_id}`, {
    name: data.name,
    layout: data.layout_id,
    marker_ids: data.marker_ids,
    photo_ids: data.photo_ids || [],
    coordinates: data.coordinates,
  })).data;
};

export const savePhotoMarkers = async (
  layoutId: string,
  markers: PhotoMarker[],
  markerAttributes: MarkerAttributes
) => {
  const markersData = markers.map((marker) => ({
    layout_id: layoutId,
    index: marker.number,
    x: marker.x,
    y: marker.y,
    width: marker.width,
    height: marker.height,
    font_size: marker.fontSize,
  }));

  return (
    await POST(
      `/layouts/${layoutId}/markers/`,
      { markers: markersData, markerAttributes },
      { 'Content-Type': 'application/json' }
    )
  ).data;
};

export const getProjectUsers = async (projectId: string) => {
  return (await GET(`/project-users/?project_id=${projectId}`)).data;
};

export const saveLayoutPhoto = async (layoutId: string, photoFile: File): Promise<{ status: string; photo_url: string }> => {
  const formData = new FormData();
  formData.append('layout_id', layoutId);
  formData.append('photo', photoFile);

  const response = await POST('/layouts/save-photo/', formData);
  return response.data;
};
